









































































































































































import { snakeCase } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { ValidationObserver } from 'vee-validate'
import { Component, Mixins } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../logic/helpers/DrawerWidthMixin'
import Accordion from '../../../Accordion/Accordion.vue'
import Tags from '../../../Tags/Tags.vue'
import ButtonsBuilderMixin from './ButtonsBuilderMixin'
import { AvailableButtonsItems } from './buttons/types'

@Component({
  components: {
    ValidationObserver,
    Tags,
    Accordion,
  },
  data() {
    return {
      snakeCase,
      isMobile,
      AvailableButtonsItems,
    }
  }
})
export default class ButtonsBuildManager extends Mixins<DrawerWidthMixin, ButtonsBuilderMixin>(DrawerWidthMixin, ButtonsBuilderMixin) {
}
